import ServiceGraphQL from 'src/service/gql-service';
import { removeInvoice } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const RemoveInvoice = (id) => {
  const params = {
    query: removeInvoice.QUERY,
    variables: {
      filter: {
        _id: id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
